/* CheckinChart auto-generated by npm run generator */
// waiting for this PR to be merged to use the main package:
// https://github.com/kevinsqi/react-calendar-heatmap/pull/128
// import CalendarHeatmap from "react-calendar-heatmap"
// @ts-ignore
import CalendarHeatmap from "@freecodecamp/react-calendar-heatmap"
import { makeStyles, Tooltip } from "@material-ui/core"
import { Client } from "@qlarity/common"
import ChartCard from "components/atoms/ChartCard"
import { observer } from "mobx-react"
import React from "react"
import "react-calendar-heatmap/dist/styles.css"

interface CheckinChartProps {
    client: Client
}

const useStyles = makeStyles((theme) => ({
    container: {
        height: 250,
        paddingRight: theme.spacing(1),
        "& .react-calendar-heatmap": {
            height: "100%",
            "& .qlarity-1": {
                fill: theme.palette.primary.light,
            },
            "& .qlarity-2": {
                fill: theme.palette.primary.main,
            },
            "& .qlarity-3": {
                fill: theme.palette.primary.dark,
            },
            "& .react-calendar-heatmap-weekday-label": {
                ...theme.typography.subtitle2,
                color: theme.palette.text.secondary,
                fontSize: 8,
            },
            "& .react-calendar-heatmap-month-label": {
                ...theme.typography.subtitle1,
                color: theme.palette.text.secondary,
                fontSize: 9,
            },
        },
    },
}))

const CheckinChart: React.FC<CheckinChartProps> = ({ client }) => {
    const classes = useStyles()

    const to = new Date()
    const from = new Date()
    // Show 150 days of data
    from?.setDate(from.getDate() - 150)

    const preparedData = React.useMemo(() => {
        const dateStrings = client.checkins?.map((checkin) => {
            const date = checkin.timestamp.toDate()
            const dateString = new Date(date.getTime() - date.getTimezoneOffset() * 60000).toISOString().split("T")[0]
            return dateString
        })
        const data: { [x: string]: number } = {}
        dateStrings?.forEach((date) => {
            data[date] = data[date] ? data[date] + 1 : 1
        })
        return Object.entries(data).map((datum) => {
            // PR for off by one fix: https://github.com/kevinsqi/react-calendar-heatmap/pull/128
            const offByOneDate = new Date(datum[0])
            offByOneDate.setDate(offByOneDate.getDate() + 1)
            return { date: offByOneDate, checkins: datum[1], label: offByOneDate.toLocaleDateString() }
        })
    }, [client.checkins])
    if (!client.checkins) {
        return null
    }

    return (
        <ChartCard title="Check ins" subtitle="Frequency">
            <div className={classes.container}>
                <CalendarHeatmap
                    values={preparedData}
                    startDate={from}
                    classForValue={(value: any) => {
                        if (!value) {
                            return "color-empty"
                        }
                        if (value.checkins === 1) return `qlarity-1`
                        if (value.checkins < 4) return `qlarity-2`
                        if (value.checkins >= 4) return `qlarity-3`
                    }}
                    transformDayElement={(element: JSX.Element, value: any, index: number) => {
                        if (value) {
                            return (
                                <Tooltip key={value.date} title={`${value.label}: ${value.checkins} check in${value.checkins > 1 ? "s" : ""}`}>
                                    {element}
                                </Tooltip>
                            )
                        } else if (from) {
                            const newDate = new Date(from.valueOf())
                            // the first index corresponds to the day of week the first entry is. Use the offset to get the date of days without values
                            const offset = from.getDay()
                            newDate.setDate(newDate.getDate() + index - offset)
                            return (
                                <Tooltip key={newDate.valueOf()} title={`${newDate.toLocaleDateString()}: 0 check ins`}>
                                    {element}
                                </Tooltip>
                            )
                        }
                    }}
                    endDate={to}
                    showWeekdayLabels
                    gutterSize={2}
                />
            </div>
        </ChartCard>
    )
}

export default observer(CheckinChart)
